import { throttle } from './common'

if (document.body.classList.contains('with-site-message')) {
    const container = document.querySelector('.site-message')
    const text = container.querySelector('.wrap')

    const calc = () => {
        container.style.setProperty('--container', container.offsetWidth)
        container.style.setProperty('--text', text.offsetWidth)
    }

    window.addEventListener('resize', throttle(calc, 100))
    calc()
}
